/**
 * Copy text to clipboard for sharing page URL
 *
 * @author Matt Haynes <mattgh9152@gmail.com>
 * @package OnlineGambling - Sex on Screen
 */

const copyToClipboard = () => {
    const copyButton = Array.from(document.querySelectorAll('.copy'));
    const copyText = document.getElementById('copyText');
    const copyTextIframe = document.getElementById('copyTextIframe');
    const copyTextSuccess = document.querySelectorAll('.copied');
    if (!copyButton || !copyText || !copyTextSuccess) return;

    copyButton.forEach(button => button.addEventListener('click', () => {
        if (button.classList.contains('iframe')) {
            /* Select the text field */
            copyTextIframe.select();
            /* For mobile devices */
            copyTextIframe.setSelectionRange(0, 99999);
        } else {
            /* Select the text field */
            copyText.select();
            /* For mobile devices */
            copyText.setSelectionRange(0, 99999);
        }
        /* Run copy command */
        document.execCommand('copy');
        /* Show success copy */
        copyTextSuccess.forEach(text => {
            if (button.dataset.copied === text.dataset.copied) {
                text.classList.add('show');
                setTimeout(() => text.classList.remove('show'), 5000);
            }
        });
    }));
};

export default copyToClipboard;
